
export class CardModel {

    constructor(
        public caminho?: string,
        public sigla?: string,
        public descricao?: string,
        public caminhoImagem?: string,
        public tipoCaminho?: number,
        public numeroOrdem?: number,
    ) {
    }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/models/card.model.ts